/* Native details works without JavaScript; enhancement adds deliberate hover and focus handling. */
if (!customElements.get('fp-category-navigation')) {
  customElements.define('fp-category-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.menus = [...this.querySelectorAll('.fp-cnav__details')];
      this.timers = new Map();
      this.desktop = this.dataset.layout === 'desktop';
      this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      this.menus.forEach(details => {
        const summary = details.querySelector('summary');
        summary.setAttribute('aria-expanded', String(details.open));
        summary.addEventListener('click', event => {
          event.preventDefault();
          this.clearTimers();
          this.setOpen(details, !details.open);
        }, options);
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) this.positionPanel(details);
        }, options);
        details.addEventListener('pointerenter', event => {
          if (!this.desktop || !this.hoverQuery.matches || event.pointerType !== 'mouse') return;
          this.clearTimer(details);
          if (!details.open) this.timers.set(details, setTimeout(() => this.setOpen(details, true), 350));
        }, options);
        details.addEventListener('pointerleave', event => {
          if (!this.desktop || !this.hoverQuery.matches || event.pointerType !== 'mouse') return;
          this.clearTimer(details);
          if (!details.contains(document.activeElement)) {
            this.timers.set(details, setTimeout(() => this.setOpen(details, false), 200));
          }
        }, options);
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const current = event.target.closest('.fp-cnav__details[open]') || this.menus.find(menu => menu.open);
        if (current) {
          event.preventDefault();
          event.stopPropagation();
          this.clearTimers();
          this.setOpen(current, false);
          current.querySelector('summary').focus();
        }
      }, options);
      this.addEventListener('focusout', event => {
        this.menus.forEach(details => {
          if (details.open && details.contains(event.target) && !details.contains(event.relatedTarget)) this.setOpen(details, false);
        });
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeAll();
      }, options);
      document.addEventListener('mobile-menu:close', () => this.closeAll(), options);
      document.addEventListener('keydown', event => {
        if (this.desktop || event.key !== 'Escape' || event.defaultPrevented) return;
        const mobileMenu = this.closest('.mobile-menu');
        if (mobileMenu?.contains(event.target) && document.body.classList.contains('mobile-menu-open')) {
          event.preventDefault();
          this.closest('header')?.querySelector('.head-slot-nav-mobile-link')?.click();
        }
      }, options);
      window.addEventListener('resize', () => this.closeAll(), options);
      document.addEventListener('shopify:block:select', event => {
        const target = event.target.closest?.('.fp-cnav__category')?.querySelector('details');
        if (target && this.contains(target)) this.setOpen(target, true);
      }, options);
    }
    clearTimer(details) { clearTimeout(this.timers.get(details)); this.timers.delete(details); }
    clearTimers() { this.timers.forEach(timer => clearTimeout(timer)); this.timers.clear(); }
    setOpen(details, open) {
      this.clearTimer(details);
      if (open) this.menus.forEach(other => {
        if (other !== details) { this.clearTimer(other); other.open = false; other.querySelector('summary').setAttribute('aria-expanded', 'false'); }
      });
      details.open = open;
      details.querySelector('summary').setAttribute('aria-expanded', String(open));
      if (open) this.positionPanel(details);
    }
    closeAll() { this.clearTimers(); this.menus.forEach(details => this.setOpen(details, false)); }
    positionPanel(details) {
      if (!this.desktop || !details.open) return;
      const panel = details.querySelector('.fp-cnav__panel');
      panel.style.setProperty('--panel-shift', '0px');
      const rect = panel.getBoundingClientRect();
      const shift = Math.max(16 - rect.left, Math.min(0, window.innerWidth - 16 - rect.right));
      panel.style.setProperty('--panel-shift', shift + 'px');
      panel.style.setProperty('--panel-max-height', Math.max(100, window.innerHeight - rect.top - 24) + 'px');
    }
    disconnectedCallback() { this.clearTimers(); this.controller?.abort(); }
  });
}

